// instead of importing firebase from 'firebase', this just imports the modules that are used
// ensure any others are added, as this is not type-safe and will throw at runtime if the required modules aren't loaded
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'

import FirebaseConfig from './FirebaseConfig'

const FirebaseApp = firebase.initializeApp(FirebaseConfig, 'iconic-configurator')

export default FirebaseApp
